// Como Usar
// Declarar import formatDate from '../../formatters/date';

// Formateo fecha 
// formatDate(row.date, {year: 'numeric', month: 'short', day: 'numeric',})
// formatDate(data?.date)
import moment from "moment";

export const formatDate = (date) => {
  return moment(date).format("DD/MM/YYYY");
};

export const formatDateTime = (date) => {
  return moment(date).format("DD/MM/YYYY HH:mm");
};

export const formatDateIso = (date) => {
  return moment(date).format("YYYY/MM/DD");
};

//const formatDate = (
//  date,
//  style = {
//    dateStyle: 'short'
//  }
//) => new Date(date).toLocaleDateString('es-CL', style);

export default (formatDate,formatDateTime,formatDateIso);

